export default "__VITE_ASSET__CT9sK57i__"